import React from "react";
import Cell from "../Cell";
import ModulePropertyDialog from "../ModulePropertyDialog";
import SectionPropertyDialog from "../SectionPropertyDialog";
import { HANDLE_NAMES } from "../../../constants";
import { isMobileOnly } from "react-device-detect";

const HandleCell = ({
  type,
  rowId,
  sectionId,
  tableManager,
  propertyList = [],
  viewMode,
  reviewColumnColorMap,
  onValueChange,
  dialogProps,
}) => {
  const getCellBackgroundColor = (column, value) => {
    if (!reviewColumnColorMap) return null;

    // Always use column-specific key to match the color map format
    const normalizedValue = value || "";
    const mapKey = `${column}__${normalizedValue}`;

    return reviewColumnColorMap[mapKey] || null;
  };

  const property = propertyList.find(
    (prop) => prop.identifier === "handle_type"
  );

  const selectedOption =
    property && property.options.find((opt) => opt.selected);

  const handleIdentifiers = [
    "g_profile",
    "j_profile",
    "gola_profile_floor",
    "gola_profile_wall",
  ];

  let finishName = null;

  if (
    property &&
    selectedOption &&
    handleIdentifiers.includes(selectedOption.identifier)
  ) {
    const finishProperty = propertyList.find(
      (prop) => prop.identifier === `${selectedOption.identifier}_finish`
    );

    finishName = finishProperty?.options?.find((opt) => opt.selected)?.name;
  }

  let value = "";

  if (property && selectedOption) {
    if (viewMode === "review" && type === "module") {
      value = `${HANDLE_NAMES[selectedOption.identifier]}${
        finishName ? ` - ${finishName}` : ""
      }`;
    } else if (property.is_overridden_v2 || type === "section") {
      value = `${HANDLE_NAMES[selectedOption.identifier]}${
        finishName ? ` - ${finishName}` : ""
      }`;
    }
  }

  if (viewMode === "review" && type === "module")
    onValueChange(rowId, "review_handle_type", (value || "").trim());

  const backgroundColor =
    viewMode === "review"
      ? getCellBackgroundColor("review_handle_type", value)
      : undefined;

  const properties = propertyList.filter((prop) =>
    [
      "handle_type",
      "handle_position",
      "g_profile_finish",
      "j_profile_finish",
      "gola_profile_floor_finish",
      "gola_profile_wall_finish",
    ].includes(prop.identifier)
  );

  return (
    <Cell
      rowId={rowId}
      sectionId={sectionId}
      rowType={type}
      column="handle"
      className="flex-grow-0 flex-shrink-0"
      customStyles={{
        width: isMobileOnly ? "15%" : "120px",
        backgroundColor: backgroundColor || undefined,
      }}
      tableManager={tableManager}
    >
      <div className="fs-10px">{value}</div>

      {tableManager.isActive(type, rowId, "handle") &&
        (type === "module" ? (
          <ModulePropertyDialog {...dialogProps} properties={properties} />
        ) : (
          <SectionPropertyDialog {...dialogProps} properties={properties} />
        ))}
    </Cell>
  );
};

export default HandleCell;
